import { render } from "./HotelsCity.vue?vue&type=template&id=e5467b8c"
import script from "./HotelsCity.vue?vue&type=script&lang=js"
export * from "./HotelsCity.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__